export class CaseServiceModel{
    public id: number;
    public name: string;
    public description: string;
    public caseTypeIds: number[];
}
